var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"cases",attrs:{"title":"Cases"}},[(false)?_c('button-view',{attrs:{"slot":"tools","label":"Opret"},slot:"tools"}):_vm._e(),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Modtaget',
			value: 'received'
		},
		{
			label: 'Åben',
			value: 'open'
		},
		{
			label: 'Lukket',
			value: 'closed'
		}
	]},slot:"tools",model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}}),_c('new-table-view',{ref:"table",attrs:{"columns":[
		{
			label: 'Status',
			name: ['status'],
			translation: _vm._status,
			template: {
				name: 'status',
				params: {
					color: {
						name: ['status'],
						translation: _vm._statusColors
					},
					description: {
						name: ['status'],
						translation: _vm._statusDesc
					}
				}
			},
			weight: 2
		},
		{
			label: 'Oprettet',
			name: 'created',
			filter: 'date',
			weight: 2
		},
		{
			label: 'Afsluttet',
			name: 'closed',
			filter: 'date',
			weight: 2
		},
		{
			label: 'Opgave',
			name: ['_embedded', 'task', 'num'],
			align: 'right',
			weight: 1
		},
		{
			label: 'Type',
			name: ['_embedded', 'type'],
			weight: 1
		},
		{
			label: 'Tur',
			name: ['_embedded', 'tour'],
			align: 'right',
			weight: 1
		},
		{
			label: 'Kunde',
			name: ['details', 'contact', 'name'],
			weight: 2
		},
		{
			label: 'Skadesum',
			name: ['sum'],
			align: 'right',
			filter: 'number',
			weight: 2
		},
		{
			label: 'Medarb. andel',
			name: ['_embedded', 'employee_part'],
			align: 'right',
			filter: 'number',
			weight: 2
		},
		{
			label: 'Forsikr. andel',
			name: 'insurance_part',
			align: 'right',
			filter: 'number',
			weight: 2
		},
		{
			label: 'Intern andel',
			name: 'internal_part',
			align: 'right',
			filter: 'number',
			weight: 2
		},
		{
			label: '',
			name: 'context',
			align: 'right',
			template: {
				name: 'button',
				label: '...'
			},
			weight: 1
		}
	],"items":_vm._items},on:{"itemClick":_vm.itemClick,"context":_vm.itemContext}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }